import React, {SelectHTMLAttributes} from 'react';
import { Corner, Shadow } from '../../utils/utils';
import clsx from 'clsx';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import uiConfig from '../../data/uiConfig';

export type Option = {
  label: string;
  value: string;
};

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  options: Option[];
  name: string;
  label?: string;
  labelColor?: string;
  disabled?: boolean;
  width?: number | string;
  corner?: Corner;
  shadow?: Shadow;
  bgColor?: string;
  color?: string;
  borderColor?: string;
  iconColor?: string;
  optionClass?: string;
  className?: string;
}

export const Select: React.FC<SelectProps> = ({
  options,
  value,
  name,
  label,
  labelColor = uiConfig.input.labelColor,
  onChange,
  disabled,
  width = 20,
  corner = uiConfig.input.corner as Corner,
  shadow = uiConfig.input.shadow as Shadow,
  bgColor = uiConfig.input.bgColor,
  color = uiConfig.input.color,
  borderColor = uiConfig.input.borderColor,
  iconColor = uiConfig.input.iconColor,
  optionClass,
	required,
  className,
	...props
}) => {
  const id = React.useId();
  return (
    <div
      className="w-fit"
      style={{
        width: typeof width === 'number' ? `${width}rem` : width
      }}
    >
	    {label && (
		    <label className={`block mb-1 font-thin ${labelColor}`}>
			    {label}
			    {required &&
				    <span className='text-alert ml-1'>*</span>
			    }
		    </label>
	    )}
      <div
        className="relative"
      >
        <select
          aria-label={name}
          id={id}
          value={value}
          onChange={onChange}
          className={clsx(
            'px-3 py-2 outline-none transition-all appearance-none w-full',
            bgColor,
            color,
            corner,
            shadow,
            borderColor && `border ${borderColor}`,
            className
          )}
          {...props}
        >
          <option
            value=""
            disabled
            className={optionClass}
          >
            {name}
          </option>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value} label={opt.label}>
              {opt.label}
            </option>
          ))}
        </select>
        {/* Flèche custom */}
        <span className="pointer-events-none absolute right-3 top-3">
          <ChevronDownIcon className={`w-5 h-5 ${iconColor}`} />
        </span>
      </div>
    </div>

  );
};
